export interface Theme {
  id: string;
  name: string;
  emoji: string;
  description: string;
  /** Gradient string shown in the swatch preview */
  previewGradient: string;
}

/**
 * 7 visual themes. Each maps to a body[data-theme="id"] block in index.css
 * that overrides the CSS custom properties.
 */
export const THEMES: Theme[] = [
  {
    id: 'cosmic',
    name: 'Cosmic',
    emoji: '🌌',
    description: 'Rainbow in the void',
    previewGradient: 'linear-gradient(135deg, #ff0000, #ff9a00, #4fdc4a, #1c7fee, #5f15f2, #fb07d9)',
  },
  {
    id: 'neon-arcade',
    name: 'Neon Arcade',
    emoji: '🕹️',
    description: 'Insert coin to continue',
    previewGradient: 'linear-gradient(135deg, #00ffff, #0055ff, #ff00ff, #ff0088)',
  },
  {
    id: 'vaporwave',
    name: 'Vaporwave',
    emoji: '🌴',
    description: 'A E S T H E T I C',
    previewGradient: 'linear-gradient(135deg, #ff71ce, #b967ff, #05ffa1, #01cdfe)',
  },
  {
    id: 'toxic',
    name: 'Toxic',
    emoji: '☢️',
    description: 'Do not eat',
    previewGradient: 'linear-gradient(135deg, #00ff41, #39ff14, #ccff00, #00ff99)',
  },
  {
    id: 'void',
    name: 'Void',
    emoji: '⬛',
    description: 'Nothing. Silence.',
    previewGradient: 'linear-gradient(135deg, #ffffff, #aaaaaa, #555555, #111111)',
  },
  {
    id: 'inferno',
    name: 'Inferno',
    emoji: '🔥',
    description: 'Too hot to handle',
    previewGradient: 'linear-gradient(135deg, #ff0000, #ff4500, #ff8c00, #ffd700)',
  },
  {
    id: 'holographic',
    name: 'Holographic',
    emoji: '✨',
    description: 'Iridescent everything',
    previewGradient: 'linear-gradient(135deg, #ffb3ba, #ffdfba, #ffffba, #baffc9, #bae1ff, #e8baff)',
  },
];

export const DEFAULT_THEME_ID = 'cosmic';
